module.exports = __webpack_public_path__ + "static/media/hat_jeff.075e6110.jpg";